/**
 * Open/close state for the Shipping/Rail/Truck Backup Days Matrix dialog,
 * opened from the Dynamic value chooser. Row data lives in React Query —
 * see `useBackupDays` in `src/hooks/useBackupDays.ts`.
 */
import { create } from 'zustand'

interface BackupDaysDialogState {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const useBackupDaysStore = create<BackupDaysDialogState>(set => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))
